<template>
  <a-space v-bind="attrs" :class="bem.b()">
    <!-- 1.默认内容插槽 -->
    <slot />
    <!-- 2.组件分割插槽 -->
    <template v-if="$slots.split" #split>
      <slot name="split" />
    </template>
  </a-space>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'

// 1.defineOptions
defineOptions({ name: 'LlSpace' })

// 2.props
const attrs = useAttrs()

// 3.computes/const
const bem = createNamespace('space')
</script>
